import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { ifProp } from 'styled-tools';
import { shallowEqual } from 'recompose';

import { Block } from 'shared-components';

import { GuestListEntryContent } from 'containers';

const StyledBlock = styled(Block)`
  transition: all 0.2s;
  border-top: 1px solid #dfe9f2;
  border-bottom: 0 solid #dfe9f2;
  position: relative;

  .expanded-row {
    transition: all .2s;
    height: 0;
    opacity: 0;
  }

  .expanded-row-content {
    display: flex;
    align-items: center;

  }

  &:last-child {
    border-bottom: 1px solid #dae6f2;
  }

  ${ifProp('selected', css`
    &,
    & + ${Block} {
      border-top-color: #b8c8d9;
    }

    &:last-child {
      border-bottom-color: #b8c8d9;
    }
  `)}

  ${ifProp('expanded', css`
    &,
    & + ${Block} {
      border-top-width: 15px;
    }

    &:last-child {
      border-bottom-width: 5px;
    }

    .expanded-arrow {
      transform: rotate(180deg);
    }

    .expanded-row {
      height: 3.25em;
      opacity: 1;
      border-top: 1px solid #ebf1f7;

      &.with-passport-info {
        height: 6.5em !important;
      }

      input {
        height: 20px;
        padding: 5px 20px 5px 10px;
        width: calc(100% - 34px);
        font-size: 13px;
      }
    }
  `)}
`;
StyledBlock.propTypes = {
  expanded: PropTypes.bool,
  selected: PropTypes.bool,
};

class GuestListEntry extends React.Component {

  static propTypes = {
    id: PropTypes.string.isRequired,
    departureId: PropTypes.string.isRequired,
    widths: PropTypes.object,
    expanded: PropTypes.bool,
    number: PropTypes.number,
    guest: PropTypes.array,
  };
  static defaultProps = {
    widths: {},
    expanded: false,
    number: 0,
  };

  constructor(props) {
    super(props);

    this.state = {
      selected: false,
      hover: false,
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { selected, hover } = this.state;
    return (
      (selected || hover) !== (nextState.selected || nextState.hover)
      || !shallowEqual(this.props, nextProps)
    );
  }

  onBlur = () => {
    this.setState(state => ({ ...state, selected: false }));
  }

  onFocus = () => {
    this.setState(state => ({ ...state, selected: true }));
  }

  onMouseEnter = () => {
    this.setState(state => ({ ...state, hover: true }));
  }

  onMouseLeave = () => {
    this.setState(state => ({ ...state, hover: false }));
  }

  render() {
    const {
      id,
      number,
      widths,
      expanded,
      departureId,
      guest,
    } = this.props;
    return (
      <StyledBlock
        expanded={expanded}
        selected={this.state.selected || this.state.hover}
        onFocus={this.onFocus}
        onBlur={this.onBlur}
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
      >
        <GuestListEntryContent
          id={id}
          number={number}
          widths={widths}
          departureId={departureId}
          guest={guest}
        />
      </StyledBlock>
    );
  }
}

export default GuestListEntry;



// WEBPACK FOOTER //
// ./src/components/organisms/GuestListEntry/index.js